<template>
  <div>
    <h1>{{ stepState.name }}</h1>
    <form v-if="!complete" ref="profileForm" @submit.prevent="saveProfile">
      <div v-if="submitError" class="alert alert-danger">
        {{ $t('enrollmentStep.profile.refreshPage') }}
      </div>

      <!-- instructions and profile fields -->
      <div v-if="stepState.instructions" v-html="$sanitize(stepState.instructions)" />

      <fieldset class="no-legend">
        <ProfileFields
          ref="profileFields"
          v-model="profileFields"
          :config="stepState.fields"
          :accountId="account.id"
        />

        <button
          type="submit"
          class="btn btn-primary"
          data-submit
        >
          {{ $t('enrollmentStep.profile.saveProfile') }}
        </button>
      </fieldset>
    </form>
    <template v-else>
      <!-- confirmation -->
      <div v-html="$sanitize(stepState.confirmation)" />
      <button
        class="btn btn-primary"
        @click="$emit('refresh')"
      >
        {{ $t('continue') }}
      </button>
    </template>
  </div>
</template>

<script>
  import BaseStep from './BaseStep.vue';
  import ProfileFields from './ProfileFields.vue';

  export default {
    components: {
      ProfileFields
    },
    extends: BaseStep,
    data() {
      return {
        complete: false,
        submitError: false,
        profileFields: {
          first_name: '',
          last_name: '',
          email: '',
          username: '',
          date_of_birth: '',
          cell_phone: '',
          home_phone: '',
          street_address: '',
          street_address2: '',
          city: '',
          state_region: '',
          postal_code: '',
          time_zone: '',
          locale: '',
          external_id: '',
          // notification prefs
          notify_email: false,
          notify_text: false,
          notify_voice: false,
        }
      }
    },
    methods: {
      init() {
        this.$api.Participants.getParticipant({
          participant_id: this.participantId
        }).then(({body}) => {
          let me = body.data;

          Object.keys(this.profileFields).forEach((key) => {
            if (me[key]) {
              this.profileFields[key] = me[key];
            }
          });

          this.$emit('ready');
        });// TODO catch
      },
      saveProfile() {
        this.$refs.profileFields.validate().then((result) => {
          if (!result) {
            return;
          }

          // get list of visible form field names
          let visibleFields = Array.from(this.$refs.profileForm.elements).map((field) => field.name);

          // generate patch operation for each field that's visible
          // should this only patch fields that have changed?
          let patch = Object.keys(this.profileFields).filter((field) => {
            return visibleFields.includes(field);
          }).map((field) => {
            return { op: "replace", path: `/${field}`, value: this.profileFields[field] };
          });

          return this.$api.Participants.updateParticipant({
            participant_id: this.participantId,
            patch: patch
          }).then(({status, body}) => {
            if (status >= 400) {
              throw {status: status, body: body};
            }

            return this.$api.FeedbackEvents.updateFeedbackEvent({
              event_id: this.stepState.id,
              patch_content: [
                { op: "replace", path: '/completed', value: true }
              ]
            });
          }).then(({status, body}) => {
            if (status >= 400) {
              throw {status: status, body: body};
            }

            if (this.stepState.confirmation) {
              this.complete = true;
            } else {
              this.$emit('refresh');
            }
          }).catch((error) => {
            // sentry?
            if (error.response && error.response.body && error.response.body.field_errors) {
              this.$refs.profileFields.pushLocalizedErrors(error.response.body.field_errors);
            }
            this.submitError = true;
          });
        });
      }
    }
  }
</script>

<style scoped>
  .no-legend {
    padding-top: 20px;
  }
</style>
